// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	env      : 'beta',
	firebase : {
		apiKey            : 'AIzaSyArLKYAWrHmWRTQEbjxUZwWnyQ9GypyfbQ',
		authDomain        : 'cartmigo-beta.firebaseapp.com',
		databaseURL       : 'https://cartmigo-beta.firebaseio.com',
		projectId         : 'cartmigo-beta',
		storageBucket     : 'cartmigo-beta.appspot.com',
		messagingSenderId : '243191127111'
  }
};


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/environments/environment.ts